import _ from 'underscore';
import { parseKeywords } from './parser';

export const suggestedKeywordItemsToKeywordsInput = (suggestedKeywordItems) => {
  if (_.isEmpty(suggestedKeywordItems)) {
    return '';
  }

  let suggestedKeywords = '';
  _.each(suggestedKeywordItems, (suggestedKeywordItem, index) => {
    suggestedKeywords = `${suggestedKeywords}${index === 0 ? '' : '\n'}${suggestedKeywordItem.Keyword}`;
  });

  return suggestedKeywords;
};

export const withNewAddedKeywords = ({ keywordsInput, newAddedKeywords }) => (
  _.isEmpty(keywordsInput) ? newAddedKeywords : `${keywordsInput}\n${newAddedKeywords}`
);

export const filterExistingKeywords = ({
  keywordSuggestions,
  keywordsInput,
  i18n,
}) => {
  let { uniqKeywords } = parseKeywords({
    keywordsTextarealVal: keywordsInput,
    i18n,
  });
  uniqKeywords = uniqKeywords.reduce((parsedKeywordsObj, keywordText) => ({
    ...parsedKeywordsObj,
    [keywordText]: keywordText,
  }), {});
  return _.filter(keywordSuggestions, suggestedKeywordItem => _.isUndefined(uniqKeywords[suggestedKeywordItem.Keyword]));
};

export const getKeywordsAdded = ({ keywordSuggestions, suggestedItems }) => {
  const suggestedItemsDict = suggestedItems.reduce((parsedKeywordsObj, suggestedItem) => ({
    ...parsedKeywordsObj,
    [suggestedItem.itemText]: suggestedItem.itemText,
  }), {});
  return _.filter(keywordSuggestions, suggestedKeywordItem => !_.isUndefined(suggestedItemsDict[suggestedKeywordItem.Keyword]));
};
